<div *nzModalTitle class="px-0 py-1 w-full grid gap-4 place-content-evenly">
    <div style="display: flex; align-items: center;">
        <p class="modal-title">{{nzModalData.nzTitle}}</p>
    </div>
</div>

<div #modalContent class="w-full h-full p-3 m-0">
    @if (isLoading) {
        <app-loader></app-loader>
    }
    @else{
        <form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm" (ngSubmit)="handleSave()">
            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="p-4">
                <nz-form-item nz-col class="px-4 w-full">
                    <nz-form-label nzRequired>
                        Artículo
                    </nz-form-label>
                    <nz-form-control nzErrorTip="Indique una descripción para la orden de producción">
                        <input onfocus="select()" nz-input type="text" id="articleName" [value]="rawMaterial.article?.name" disabled/>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item nz-col class="px-4 w-full">
                    <nz-form-label nzRequired>
                        Lote
                    </nz-form-label>
                    <nz-form-control nzErrorTip="Indique una descripción para la orden de producción">
                        <input nz-input type="text" id="batchNumber" [value]="rawMaterial.articleBatch?.batchNumber" disabled/>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item nz-col class="px-4 w-full">
                    <nz-form-label nzRequired>
                        Cantidad
                    </nz-form-label>
                    <nz-form-control nzErrorTip="Indique una cantidad para la materia prima">
                        <input formControlName="quantity" nz-input type="number" id="quantity" [value]="rawMaterial.rawQuantity" />
                    </nz-form-control>
                </nz-form-item>
            </div>
        </form>
    }
</div>

<div *nzModalFooter>
    <div class="flex justify-between w-full">
        <div>
            <button (click)="handleDelete()" class="button secondary-button" [disabled]="!rawMaterial.id">
                Eliminar
            </button>
        </div>

        <div class="flex space-x-2">
            <button (click)="handleCancel()" class="button secondary-button">
                Cancelar
            </button>
            <button (click)="handleSave()" class="button secondary-button">
                Aceptar
            </button>
        </div>
    </div>
</div>
